import { AccountSetting, Profile } from 'types/profile'

export function getProfilePhoto(profile: Profile): string {
  return profile.verified_avatar_url || profile.avatar_url || ''
}

export const getLatestAccountSetting = (accountSettings: AccountSetting[], settingName: string) => {
  const accountSetting = accountSettings.filter((item) => item.setting === settingName)
  accountSetting.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
  return accountSetting.length > 0 ? accountSetting[0].value : undefined
}
